import {
  ControlledAutocomplete,
  ControlledCheckbox,
  ControlledInput,
  ControlledMultiSelect,
  ControlledRadioCard,
  ControlledRow,
  ControlledSelect,
  ControlledSwitch,
} from 'src/components/ControlledFields';
import { ControlledCrmObjectSelect } from 'src/components/Settings/Integrations/components/ControlledCrmObjectSelect';
import {
  ControlledCheckboxRow,
  DynamicSelectOptionsForm,
  SecondaryInput,
  DateRangeForm,
} from 'src/components/Settings/Integrations/components/CRMMappings/Options/components';

export const inputKeyMap = {
  autocomplete: ControlledAutocomplete,
  checkbox: ControlledCheckbox,
  number: ControlledInput,
  integer: ControlledInput,
  radio: ControlledRadioCard,
  row: ControlledRow,
  selector: ControlledSelect,
  multi_select: ControlledMultiSelect,
  string: ControlledInput,
  key_value: DynamicSelectOptionsForm,
  switch: ControlledSwitch,
  checkbox_group: ControlledCheckboxRow,
  secondary_input: SecondaryInput,
  crm_select: ControlledCrmObjectSelect,
  boolean: ControlledCheckbox,
  date_range: DateRangeForm,
};
